<style>
</style>
<template>
  <div>
    <v-tooltip bottom v-if="!card.isActive || !card.isValid || card.blocked">
      <template v-slot:activator="{ on }">
        <v-btn icon disable class="mx-0">
          <v-icon color="red" class="fa fa-ban" v-on="on"></v-icon>
        </v-btn>
      </template>
      <span>{{ $t('Blokovaná') }}</span>
    </v-tooltip>
    <v-tooltip bottom v-else>
      <template v-slot:activator="{ on }">
        <v-btn icon disable class="mx-0">
          <v-icon color="green" class="fa fa-check" v-on="on"></v-icon>
        </v-btn>
      </template>
      <span>{{ $t('Aktivní') }}</span>
    </v-tooltip>
    <v-tooltip bottom v-if="hasEticket(card)">
      <template v-slot:activator="{ on }">
        <v-btn icon disable class="mx-0">
          <v-icon color="green" class="fa fa-ticket-alt" v-on="on"></v-icon>
        </v-btn>
      </template>
      <span>{{ $t('E-ticket') }}</span>
    </v-tooltip>
    <v-tooltip bottom v-if="hasCharge(card)">
      <template v-slot:activator="{ on }">
        <v-btn icon disable class="mx-0">
          <span class="subheading green--text" v-on="on">{{ chargeTotal(card) | hundred }}</span>
        </v-btn>
      </template>
      <span>{{ $t('Dobít') }}</span>
    </v-tooltip>
    <v-tooltip bottom v-if="hasRates(card)">
      <template v-slot:activator="{ on }">
        <v-btn icon disable class="mx-0">
          <v-icon color="green" class="fa fa-cogs" v-on="on"></v-icon>
        </v-btn>
      </template>
      <span>{{ $t('Nové služby') }}</span>
    </v-tooltip>
    <v-tooltip bottom v-if="hasAssociated(card)">
      <template v-slot:activator="{ on }">
        <v-btn icon disable class="mx-0">
          <v-icon color="green" class="fa fa-link" v-on="on"></v-icon>
        </v-btn>
      </template>
      <span>{{ $t('Přidružená') }}</span>
    </v-tooltip>
  </div>
</template>
<script>
import BasketMixin from '@/mixins/basket-mixin.js'

export default {
  props: {
    card: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  mixins: [BasketMixin],
  methods: {
    hasEticket(card) {
      return this.eCardItems.some(i => !!i.itemDesc && i.itemDesc.includes(card.displayedCardNo))
    },
    hasCharge(card) {
      return this.chargeItems.some(i => !!i.itemDesc && i.itemDesc.includes(card.displayedCardNo))
    },
    hasRates(card) {
      return this.rateItems.some(i => !!i.rateItem && i.rateItem.cardId === card.cardId)
    },
    hasAssociated(card) {
      return card.creditCardId !== undefined && card.creditCardId !== null
    },
    chargeTotal(card) {
      let total = 0
      this.chargeItems.filter(i => !!i.itemDesc && i.itemDesc.includes(card.displayedCardNo)).forEach(i => {
        total += i.total
      })
      return total
    }
  }
}
</script>
